import styled from 'styled-components'

const CardGridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  grid-gap: 16px;
`

export default CardGridWrapper
